"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.brevoContract = void 0;
const core_1 = require("@ts-rest/core");
const brevo_public_contract_1 = require("./brevo.public.contract");
const c = (0, core_1.initContract)();
exports.brevoContract = c.router({
    public: brevo_public_contract_1.publicBrevoContract,
}, {
    pathPrefix: '/brevo',
    strictStatusCodes: true,
});
__exportStar(require("./brevo.public.contract"), exports);
//# sourceMappingURL=index.js.map